var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-row", [
        _c(
          "div",
          { staticStyle: { padding: "10px 25px" } },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticStyle: { padding: "10px" },
                attrs: { model: _vm.form, inline: true }
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "包裹号", clearable: "" },
                      model: {
                        value: _vm.form.package_no,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "package_no", $$v)
                        },
                        expression: "form.package_no"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "包裹状态" },
                        model: {
                          value: _vm.form.packge_status,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "packge_status", $$v)
                          },
                          expression: "form.packge_status"
                        }
                      },
                      _vm._l(_vm.SEARCH_OPTIONS.PACKGE_STATUS, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "商家核对状态", clearable: "" },
                        model: {
                          value: _vm.form.check_status,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "check_status", $$v)
                          },
                          expression: "form.check_status"
                        }
                      },
                      _vm._l(_vm.SEARCH_OPTIONS.CHECK_STATUS, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "有无差异", clearable: "" },
                        model: {
                          value: _vm.form.check_result,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "check_result", $$v)
                          },
                          expression: "form.check_result"
                        }
                      },
                      _vm._l(_vm.SEARCH_OPTIONS.CHECK_RESULT, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch }
                      },
                      [_vm._v(" 查询 ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.handleListExport }
                      },
                      [_vm._v("导出列表\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.handleLogExport }
                      },
                      [_vm._v("\n            导出打标日志\n          ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading"
                }
              ],
              key: "table1",
              attrs: { data: _vm.listData, border: "", "max-height": "400px" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "left",
                  prop: "package_no",
                  label: "包裹号",
                  align: "center",
                  width: "150"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.package_no))]),
                        _vm._v(" "),
                        row.package_no === _vm.formProps.current_package_no
                          ? _c("div", [
                              _vm._v("\n            (当前包裹)\n          ")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spr_create_time_txt",
                  label: "包裹生成时间",
                  align: "center",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "packge_status_txt",
                  label: "包裹状态",
                  align: "center",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "check_status_txt",
                  label: "商家核对状态",
                  align: "center",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "check_result_txt",
                  label: "核对结果",
                  align: "center",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "total_amount_received",
                  label: "一手总收货件数",
                  align: "center",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "no_goods_nums",
                  label: "无数据件数（不含已入库）",
                  align: "center",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "stock_num",
                  label: "一手已入库数（当前实时）",
                  align: "center",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "num",
                  label: "商家配货数",
                  align: "center",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "check_sku_num",
                  width: "150",
                  label: "差异SKU个数",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "check_goods_num", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("NumColorCell", {
                            attrs: { num: row.check_goods_num || "" }
                          })
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("div", [_vm._v("当前入库差异件数")]),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "入库差异件数 = 一手已入库件数 - 商家配货件数",
                            placement: "top-start"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.handleShowLog(row)
                              }
                            }
                          },
                          [_vm._v("查看打标日志")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.handleShowNoDataGoods(row)
                              }
                            }
                          },
                          [_vm._v("查看无数据商品")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading"
                }
              ],
              key: "table2",
              attrs: { data: _vm.totalData, border: "", "show-header": false }
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { prop: "", label: "", align: "center", width: "150" }
                },
                [_vm._v("\n        合计\n      ")]
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "", align: "center", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "", align: "center", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "", align: "center", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "", align: "center", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "total_amount_received",
                  label: "",
                  align: "center",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "no_goods_nums", align: "center", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "stock_num", align: "center", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "check_details_num",
                  align: "center",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "check_sku_num", width: "150", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "feedback_num", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("NumColorCell", {
                          attrs: { num: row.feedback_num || "" }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", align: "center", fixed: "right" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bc2cacd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc2cacd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/receiveGoods/StockVarianceProcess/components/InventoryByPackage.vue
// module id = null
// module chunks = 